
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashionweeks-around-the-world-list",
      function () {
        return require("private-next-pages/fashionweeks-around-the-world-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashionweeks-around-the-world-list"])
      });
    }
  